import { EPosition } from '@summit/models';

import { assignSafe } from '@summit/core';
import { ISMapPolygon } from './i-map-polygon';

export class SMapPolygon implements ISMapPolygon {
  id: string;
  name: string;
  geometry: EPosition[];

  constructor(jsonData?: Partial<SMapPolygon>) {
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.geometry) {
        this.geometry = jsonData.geometry.map((element) => new EPosition(element));
        const lastIndex = this.geometry.length - 1;
        if (
          lastIndex > 0 &&
          (this.geometry[0].latitude != this.geometry[lastIndex]?.latitude ||
            this.geometry[0].longitude != this.geometry[lastIndex]?.longitude)
        ) {
          this.geometry.push(this.geometry[0]);
        }
      }
    }
  }
}
